// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__NGk1e","boxTitle":"Qualiphy_boxTitle__1QGLV","box":"Qualiphy_box__h9G3b","toggleWrap":"Qualiphy_toggleWrap__3iMDN"};